import React from "react";
import { Fade } from "react-reveal";
import styled from "styled-components";
import { WppButton } from "../comps/chatButton";

const Info = () => {
  return (
    <Fade left>
      <Container>
        <div>
          <img
            src="https://a2723d7d63.cbaul-cdnwnd.com/c9a4f07398f99ecd18a2ed68de83a17a/200000005-3a41a3a41c/700/images%20-%202021-07-30T150732.619.jpeg?ph=a2723d7d63"
            alt="Entre em contato"
          />
        </div>
        <WppButton height={40} text={"ENTRE EM CONTATO"} />
      </Container>
    </Fade>
  );
};

export default Info;

const Container = styled.div`
  background-color: #fff;
  border-radius: 5%;
  filter: drop-shadow(0px 1px 5px #3a3a3a);
  width: 45%;
  display: column;
  margin: auto;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 50px;
  padding-bottom: 10px;
  img {
    width: 100%;
    border-radius: 5%;
    padding-bottom: 10px;
  }
  @media (max-width: 900px) {
    width: 75%;
  }
`;
